import { FormBuilder, Validators } from '@angular/forms';
import { FormFactory } from '../../../shared/mappers/form.factory';
import { CategoryModel } from '../models/category.model';
import { CustomValidators } from '../../../shared/validators/custom-validators';

export class CategoryFormFactory {
  static createCategoryForm(fb: FormBuilder, categoryDto: CategoryModel) {
    return fb.group({
      categoryId: [categoryDto.categoryId],
      locationId: [categoryDto.locationId],
      name: FormFactory.createLocalizedTextsForm(fb, categoryDto.name),
      appointmentDurationMinutes: [categoryDto.appointmentDurationMinutes, [Validators.required, CustomValidators.integer]],
      slotDurationMinutes: [categoryDto.slotDurationMinutes, [Validators.required, CustomValidators.integer]],
      startTimeIntervalMinutes: [categoryDto.startTimeIntervalMinutes, CustomValidators.integer],
      categoryGroup: FormFactory.createLocalizedTextsForm(fb, categoryDto.categoryGroup),
      maxAppointmentFrequency: [categoryDto.maxAppointmentFrequency, CustomValidators.integer],
      bookingHint: FormFactory.createLocalizedTextsForm(fb, categoryDto.bookingHint),
      bookingConstraints: [categoryDto.bookingConstraints],
      price: [categoryDto.price]
    });
  }
}
